import * as React from 'react';
import propz from 'propz';
import { AppUser } from '../App/App';
import { LoginSession } from 'Src/models/sessions';
import { login } from 'Src/helpers/auth/auth';
import { replaceLoginSession } from '../../helpers/session/session';
import { LoginForm } from 'Src/components/LoginForm/LoginForm';
import { UserProfile } from '../../models/profile';
import { getProfile } from '../../helpers/service/admin/user';
import { History, Location } from 'history';

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  onFormSubmit: (
    userId: string,
    key: string,
    profile: UserProfile,
    options?: { isRolesNotExist?: boolean }
  ) => void;
}

interface State {
  email: string;
  password: string;
  isRememberMe: boolean;
  isError: boolean;
}

export class Login extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      isRememberMe: false,
      isError: false
    };
  }

  onEmailChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.value;
    this.setState({ email: value });
  };

  onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.value;
    this.setState({ password: value });
  };

  onFormSubmit = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    const { email, password, isRememberMe } = this.state;
    const { user, onFormSubmit, history, location } = this.props;
    let userId, key;

    login(email, password)
      .then((loginSession: LoginSession) => {
        userId = loginSession.userId;
        key = loginSession.key;

        replaceLoginSession(loginSession, { remember: isRememberMe });

        const userUpdated = {
          ...user,
          authorized: true,
          userId: userId,
          loginSessionKey: key
        };

        return getProfile(userUpdated);
      })
      .then(profile => {
        onFormSubmit(userId, key, profile);
        const isEmailVerified = propz.get(profile, ['verification', 'status', 'email']);
        const isPhoneVerified = propz.get(profile, ['verification', 'status', 'sms']);
        const isUserVerified = isEmailVerified && isPhoneVerified;

        if (isUserVerified) {
          const followUnion = new URLSearchParams(location.search).get('followUnion');
          if (followUnion || new URLSearchParams(location.search).get('role') === 'follower') {
            history.push('/follow' + (followUnion ? '?union=' + encodeURIComponent(followUnion) : ''));
            return;
          }
          history.push({
            pathname: 'role',
            state: location.state
          });
        } else {
          const params = new URLSearchParams(location.search);
          history.push(params.has('followUnion') || params.get('role') === 'follower' ? '/register' + location.search : '/profile/verification');
        }
      })
      .catch(error => {
        this.setState({ isError: true });
      });
  };

  onRememberMeChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.checked;
    this.setState({ isRememberMe: value });
  };

  render() {
    return (
      <LoginForm
        email={this.state.email}
        password={this.state.password}
        onEmailChange={this.onEmailChange}
        onPasswordChange={this.onPasswordChange}
        onFormSubmit={this.onFormSubmit}
        isRememberMe={this.state.isRememberMe}
        onRememberMeChange={this.onRememberMeChange}
        isError={this.state.isError}
      />
    );
  }
}

